import React, { Component } from 'react'
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { List } from 'immutable'

import WordCloud from "visualizations/components/WordCloud"

import { wordCloudProps } from "search-new/selectors"
import { updateExtraVisualizationData } from "search-new/action-creators"

export class WordCloudWrapper extends Component {
    static propTypes = {
        // from ListViewDisplayWrapper
        uniqueFlvId: PropTypes.string.isRequired,
        uniqueVizSceneId: PropTypes.string.isRequired,
        // from containers/Visualization/index
        data: PropTypes.object.isRequired,
        isVisualizationLoading: PropTypes.bool.isRequired,
        isVisualizationDataEmpty: PropTypes.bool.isRequired,
        storedGraphs: PropTypes.object.isRequired,
        // from word cloud connection
        updateExtraVisualizationData: PropTypes.func.isRequired,
        shownTerms: PropTypes.object.isRequired,
        hiddenTerms: PropTypes.object.isRequired,
        removedTerms: PropTypes.object.isRequired,
    }

    updateGraph = (id, size) => {
        if (size <= 20) {
            // if the word is a small word, just hide it.
            this.props.updateExtraVisualizationData(
                this.props.uniqueFlvId,
                this.props.uniqueVizSceneId,
                { hiddenTerms: [id] }
            )
        } else {
            // if the word is large enough, put it into
            // the removedTerms list, which will update 'shownTerms',
            // forcing a re-render. Move all the hidden phrases
            // into the removed terms and clear hiddenTerms,
            // because we have a new word cloud now!
            this.props.updateExtraVisualizationData(
                this.props.uniqueFlvId,
                this.props.uniqueVizSceneId,
                { removedTerms: [ id, ...this.props.removedTerms.toJS(), ...this.props.hiddenTerms.toJS() ]}
            )

            this.props.updateExtraVisualizationData(
                this.props.uniqueFlvId,
                this.props.uniqueVizSceneId,
                { hiddenTerms: null }
            )
        }
    }

    render() {
        return (
            <WordCloud
                data={this.props.shownTerms} //immutable list, for equality purposes
                hiddenTerms={this.props.hiddenTerms}
                updateGraph={this.updateGraph}
                isLoading={this.props.isVisualizationLoading}
                svgId={this.props.uniqueVizSceneId}
                colorConfigs={this.props.colorConfigs}
            />
        )
    }
}

export default connect(wordCloudProps, { updateExtraVisualizationData })(WordCloudWrapper)
